"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_tracking_1 = require("react-tracking");
var core_link_1 = require("../../components/core_link");
var lodash_1 = require("lodash");
var tracker_1 = require("../../tracker");
var sanitized_render_1 = require("../../components/sanitized_render");
var metadata_helper_1 = require("../lib/metadata_helper");
var FIRST_POSITION = 0;
var CSPWideCard = /** @class */ (function (_super) {
    tslib_1.__extends(CSPWideCard, _super);
    function CSPWideCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CSPWideCard.prototype.getBannerImage = function () {
        return null;
    };
    CSPWideCard.prototype.getBannerBackgroundStyle = function () {
        var url = this.getBannerImage();
        if (!url)
            return null;
        return { backgroundImage: "url(" + url + ")" };
    };
    CSPWideCard.prototype.getCSPImageStyle = function () {
        var url = lodash_1.get(this.props.csp, 'image.source');
        if (!url)
            return null;
        return { backgroundImage: "url(" + url + ")" };
    };
    CSPWideCard.prototype.renderPrices = function () {
        var csp = this.props.csp;
        var tags = {
            tagOpen: '<b>',
            tagClose: '</b>',
        };
        var usedLowPrice = csp.inventory.usedLowPrice;
        var newLowPrice = csp.inventory.newLowPrice;
        return (React.createElement("ul", { className: "csp-wide-card__prices" },
            usedLowPrice && this.props.conditionFilter !== 'new' &&
                React.createElement(sanitized_render_1.default, { className: "csp-wide-card__price", htmlTag: "li", html: I18n.t('cms.cspWideCard.usedPriceFrom', tslib_1.__assign({ price: usedLowPrice.display }, tags)) }),
            newLowPrice && this.props.conditionFilter !== 'used' &&
                React.createElement(sanitized_render_1.default, { className: "csp-wide-card__price", htmlTag: "li", html: I18n.t('cms.cspWideCard.newPriceFrom', tslib_1.__assign({ price: newLowPrice.display }, tags)) })));
    };
    CSPWideCard.prototype.webLink = function () {
        if (this.props.conditionFilter === 'new') {
            return this.props.csp.webLink.path + "#new_listings";
        }
        if (this.props.conditionFilter === 'used') {
            return this.props.csp.webLink.path + "#used_listings";
        }
        return this.props.csp.webLink.path;
    };
    CSPWideCard.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "csp-wide-card csp-wide-card--placeholder" },
            React.createElement("div", { className: "csp-wide-card__inner" },
                React.createElement("div", { className: "csp-wide-card__content" },
                    React.createElement("div", { className: "csp-wide-card__content__img" },
                        React.createElement("div", { className: "csp-wide-card__content__img__inner" }))))));
    };
    CSPWideCard.prototype.renderMetadata = function () {
        if (this.props.hideMetadata)
            return;
        return (React.createElement("div", null,
            React.createElement(metadata_helper_1.BrandMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.NameMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.DescriptionMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.ImageMetaData, { csp: this.props.csp }),
            React.createElement(metadata_helper_1.PriceMetaData, { csp: this.props.csp, conditionFilter: this.props.conditionFilter })));
    };
    CSPWideCard.prototype.render = function () {
        var csp = this.props.csp;
        if (!csp)
            return this.renderPlaceholder();
        return (React.createElement("article", { className: "csp-wide-card" },
            React.createElement(core_link_1.default, { className: "csp-wide-card__inner", to: this.webLink(), entityId: this.props.csp.id, position: this.props.position },
                this.getBannerImage() &&
                    React.createElement("div", { className: "csp-wide-card__banner-img", style: this.getBannerBackgroundStyle() }),
                React.createElement("div", { className: "csp-wide-card__content" },
                    React.createElement("div", { className: "csp-wide-card__content__img" },
                        React.createElement("div", { className: "csp-wide-card__content__img__inner", style: this.getCSPImageStyle() })),
                    React.createElement("div", { className: "csp-wide-card__content__details" },
                        React.createElement("h4", { className: "csp-wide-card__content__title" }, csp.title),
                        this.renderPrices(),
                        this.renderMetadata())))));
    };
    CSPWideCard.defaultProps = {
        position: FIRST_POSITION,
    };
    CSPWideCard = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                mParticleInteraction: function (data) { return tracker_1.trackCSPClick(data, props.csp, { displayStyle: 'CspWideCard' }); },
            };
        })
    ], CSPWideCard);
    return CSPWideCard;
}(React.Component));
exports.default = CSPWideCard;
//# sourceMappingURL=csp_wide_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/csp_wide_card.js
// module id = iGHU
// module chunks = 20 21